import adminAcessoRestritoService from '../../services/admin/AdminAcessoRestritoService'

/**
 * Estado da trava de senha do dia das telas /admin/logs e /admin/auditoria (#19).
 *
 * O estado aqui é só o que a tela precisa para decidir entre renderizar a view
 * ou o diálogo. Quem realmente autoriza é a sessão no servidor: o middleware
 * 'restrito' responde 423 a qualquer chamada feita sem desbloqueio, venha ela
 * da tela ou não.
 */
export const adminAcessoRestritoModule = {
  namespaced: true,

  state: {
    // null = ainda não perguntamos ao servidor. Diferente de false, que é uma
    // resposta: sem esta distinção o diálogo pisca antes da primeira consulta.
    desbloqueado: null,
    expiraEm: null,
    // null enquanto o servidor nao respondeu: o hint so aparece com um numero
    // real, nunca com um palpite do cliente.
    tentativasRestantes: null,
    maxTentativas: null,
    loading: false,
  },

  mutations: {
    SET_ACESSO(state, payload) {
      state.desbloqueado = !!(payload && payload.desbloqueado)
      state.expiraEm = (payload && payload.expira_em) || null

      if (payload && payload.tentativas_restantes !== undefined) {
        state.tentativasRestantes = payload.tentativas_restantes
      }

      if (payload && payload.max_tentativas !== undefined) {
        state.maxTentativas = payload.max_tentativas
      }
    },
    // O 422 da senha errada e o 429 do bloqueio carregam o contador no `data`
    // do ApiException, que o interceptor de services/index.js repassa intacto.
    SET_TENTATIVAS(state, restantes) {
      state.tentativasRestantes = restantes
    },
    SET_LOADING(state, loading) {
      state.loading = loading
    },
    // Volta ao estado "ainda nao perguntamos", para que nada seja renderizado
    // ate a resposta chegar.
    INVALIDAR(state) {
      state.desbloqueado = null
      state.expiraEm = null
    },
  },

  actions: {
    async verificarStatus({ commit }) {
      // Invalida ANTES de perguntar. Sem isso, entrar em /auditoria vindo de
      // /logs renderizaria a view na hora com o `desbloqueado: true` anterior
      // — e se a janela tivesse vencido, o created() dela dispararia uma
      // requisicao que toma 423 e pisca um snackbar de erro.
      commit('INVALIDAR')

      try {
        const resposta = await adminAcessoRestritoService.getStatus()
        commit('SET_ACESSO', resposta?.data)
        return resposta?.data
      } catch (error) {
        // Falhou a consulta: trata como trancado. Assumir liberado abriria a
        // tela, que então tomaria 423 na primeira requisição de dados.
        commit('SET_ACESSO', null)
        throw error
      }
    },

    async desbloquear({ commit }, { senha, tela }) {
      commit('SET_LOADING', true)

      try {
        const resposta = await adminAcessoRestritoService.unlock(senha, tela)
        commit('SET_ACESSO', resposta?.data)
        return resposta?.data
      } catch (error) {
        if (error?.data?.tentativas_restantes !== undefined) {
          commit('SET_TENTATIVAS', error.data.tentativas_restantes)
        }

        throw error
      } finally {
        commit('SET_LOADING', false)
      }
    },

    // Chamado quando o servidor responde 423 a uma tela que se julgava aberta
    // (a janela venceu com a aba em segundo plano).
    bloquear({ commit }) {
      commit('SET_ACESSO', null)
    },
  },

  getters: {
    desbloqueado: (state) => state.desbloqueado === true,
    verificado: (state) => state.desbloqueado !== null,
    expiraEm: (state) => state.expiraEm,
    tentativasRestantes: (state) => state.tentativasRestantes,
    maxTentativas: (state) => state.maxTentativas,
    loading: (state) => state.loading,
  },
}
